import type { UnisonProjectTypeId } from '@witmetrics/utils';
import { UNISON_PROJECT_TYPES } from '@witmetrics/utils/constants';
import { findById } from '@witmetrics/utils/arrays';

export function getProjectTypeLabel(typeId?: UnisonProjectTypeId) {
  if (!typeId) return 'Unison Case';
  return (
    findById(Object.values(UNISON_PROJECT_TYPES), typeId)?.label ||
    'Unison Case'
  );
}
